import { useState } from "react";
import ApiKeyForm from "./ApiKeyForm";
import ApiKeysList from "./ApiKeysList";
import { Button } from "@/components/ui/Button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/Card";

export default function ApiKeysSection() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <Card>
      <CardHeader>
        <CardTitle>API Keys</CardTitle>
        <CardDescription>Manage API keys for programmatic access to your monitors</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <ApiKeysList />

          <Button onClick={() => setFormOpen(true)} variant="outline">
            Create API Key
          </Button>

          <ApiKeyForm open={formOpen} setOpen={setFormOpen} />
        </div>
      </CardContent>
    </Card>
  );
}
